import styled from "styled-components";
import { Link } from 'react-router-dom';


export const Container = styled.div`
    width: ${({width}) => width};
    height: ${({height}) => height};
    max-height: fit-content;
    position: relative;
    border: ${props => (props.$selected ? ` 3px solid rgba(var(--cor-tema), 1)` : ' 1px solid rgba(0,0,0,0.1)')};
    padding: 2px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: all .5s;
    display: flex;

    &:hover{
        transition: all .5s;
        filter: brightness(85%);
        transform: scale(1.02) translateY(-6px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
    }
`

export const CoverAppLink = styled(Link)`
    display: flex;
    width: 100%;
    height: 100%;
    text-decoration: none;
    border-radius: 4px;
    overflow: hidden;
`

export const CoverAppImageContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    text-decoration: none;
    border-radius: 4px;
    overflow: hidden;
`

export const CoverImage = styled.img`
    width: 100%;
    height: 100%;
`

export const CoverImageText = styled.span`
    position: absolute;
    left: 0;
    top: 0;
    padding: 8px;
    color: ${({$color}) => $color};
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    max-height: 80%;
`
